import laptop from './images/laptop.jpg'
import earth from './images/earth.jpg'
import office from './images/office.jpg';
import smart from './images/smartphone.jpg'
import snap from './images/snap.jpg'

const Sdata = [
    {
        imgsrc: laptop,
        title: "Web development"
    },
    {
        imgsrc: earth,
        title: "Digital Marketing"
    },
    {
        imgsrc: office,
        title: "Marketing"
    },
    {
        imgsrc: smart,
        title: "App Development"
    },
    {
        imgsrc: laptop,
        title: "Software Development"
    },
    {
        imgsrc: snap,
        title: "Android Development"
    }
];

export default Sdata